<template>
  <div>
    <div
      class="hidden-input-form-group d-md-flex justify-content-md-between align-items-md-center"
      :class="{ active: editVisible }"
    >
      <div class="">
        <label class="font-weight-bold text-color2 font-size-regular">{{ label }}</label>
        <div class="text-input">
          <span v-if="complementInput">{{ complementInput }}</span>
          <span v-if="!mask">{{ value }}</span>
          <span v-else>{{ value | VMask(mask) }}</span>
        </div>
        <div class="editable-input">
            <span v-if="complementInput">{{ complementInput }}</span>
            <input
              :type="inputType"
              class="form-control"
              :placeholder="placeholder"
              v-model="localValue"
              @keyup.enter="confirm"
              v-if="!mask"
            />
            <TheMask
              :mask="mask"
              :type="inputType"
              v-model="localValue"
              :placeholder="placeholder"
              class="form-control"
              @keyup.enter="confirm"
              v-else
            />
        </div>
      </div>
      <div class="mt-4 text-center mt-md-0">
        <div class="controls">
          <div class="edit-controls">
            <Button
              type="button"
              class="btn-outline-color2"
              @click="editVisible = !editVisible"
              :loading="loader"
              :disabled="loader"
            >
              {{ buttonActionText }}
            </Button>
          </div>
          <div class="hidden-controls">
            <button
              type="button"
              class="btn-confirm mr-2"
              @click="confirm"
            >
              <i class="fa fa-check"></i>
            </button>
            <button
              type="button"
              class="btn-cancel"
              @click="cancel"
            >
              <i class="fa fa-close"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Button from '@/components/common/Button/Button.vue'
import { TheMask } from 'vue-the-mask'

export default {
  name: 'EditableInput',
  props: [
    'label',
    'value',
    'type',
    'placeholder',
    'complementInput',
    'buttonText',
    'loader',
    'mask'
  ],
  components: {
    Button,
    TheMask
  },
  data () {
    return {
      editVisible: false,
      localValue: ''
    }
  },
  created () {
    this.localValue = this.value
  },
  watch: {
    value (newValue, oldValue) {
      this.localValue = newValue
    }
  },
  computed: {
    inputType () {
      return this.type ? this.type : 'text'
    },
    buttonActionText () {
      return this.buttonText ? this.buttonText : 'Editar'
    }
  },
  methods: {
    cancel () {
      this.localValue = this.value
      this.editVisible = false
    },
    confirm () {
      this.editVisible = false
      this.$emit('input', this.localValue)
      this.$emit('confirm')
      if (this.localValue !== this.value) this.$emit('change')
    }
  }
}
</script>

<style lang="scss" scoped>
  .editable-input {
    .form-control {
      width: 100%;
      @include tablet {
        width: 400px;
      }
    }
  }
</style>
